import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getFamilias, createFamilia, updateFamiliaById, deleteFamiliaById } from "../api";

const FilterTableFamilia = () => {
  const [Familias, setFamilias] = useState([]);
  const [filteredFamilias, setFilteredFamilias] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "", herramienta_consumible: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchFamilias = async () => {
    try {
      const response = await getFamilias();
      setFamilias(response.data);
      setFilteredFamilias(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching familias:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchFamilias();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = Familias.filter((Familia) =>
        Familia.descripcion.toLowerCase().includes(filterText.toLowerCase()) ||
        Familia.herramienta_consumible.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredFamilias(filtered);
    } else {
      setFilteredFamilias(Familias);
    }
  }, [filterText, Familias]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateFamiliaById(formData.id, { descripcion: formData.descripcion, herramienta_consumible: formData.herramienta_consumible  });
        alert("Familia actualizado con éxito.");
      } else {
        await createFamilia(formData);
        alert("Familia registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "", herramienta_consumible: "" });
      setIsEditing(false);
      fetchFamilias();
    } catch (error) {
      console.error("Error procesando el familia:", error);
    }
  };

  const handleEdit = (Familia) => {
    setFormData(Familia);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "", herramienta_consumible: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar esta familia?")) {
      try {
        await deleteFamiliaById(id);
        alert("Familia eliminado con éxito.");
        fetchFamilias();
      } catch (error) {
        console.error("Error eliminando la familia:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Familia" : "Agregar Familia"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label2">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">Tipo</label>
          <select
            name="herramienta_consumible"
            value={formData.herramienta_consumible}
            onChange={handleChange}
            className="input-form-1"
          >
            <option value="Maquinaria/Herramienta">Maquinaria/Herramienta</option>
            <option value="Consumible">Consumible</option>
          </select>
        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por descripción..."
          className="input2"
        />
      </div>
      {filteredFamilias.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th>Tipo</th>
              <th colSpan="2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredFamilias.map((Familia) => (
              <tr key={Familia.id}>
                <td>{Familia.id}</td>
                <td>{Familia.descripcion}</td>
                <td>{Familia.herramienta_consumible}</td>
                <td>
                  <button onClick={() => handleEdit(Familia)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(Familia.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableFamilia.propTypes = {
  familia: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
      herramienta_consumible: PropTypes.string,
    })
  ),
};

export default FilterTableFamilia;
